import { PropsWithChildren } from "react";

import classes from "./HeaderSlot.module.css";

type Props = PropsWithChildren;

export const HeaderSlot = ({ children }: Props) => {
  return <div className={classes.slot}>{children}</div>;
};
